(function(){
  'use strict';
  var root = document.getElementById('icb'); if (!root) return;
  var data = JSON.parse(document.getElementById('icb-data').textContent);
  var byHandle = {}; data.products.forEach(function(pr){ byHandle[pr.handle] = pr; });
  var cur = byHandle[data.current];
  function tierPrice(q){ return data.tiers[String(q)] || ''; }
  // slot 1 starts on the shirt being viewed; the others start empty ("pick any icon")
  var state = { qty: 2, slots: [] };
  for (var i = 0; i < 4; i++) state.slots.push({ handle: i === 0 ? data.current : null, size: null });

  var atc = document.getElementById('icb-atc');
  var atcLabel = atc.querySelector('.icb-atc-label');
  var atcPrice = atc.querySelector('.icb-atc-price');
  var note = document.getElementById('icb-atc-note');
  var sticky = document.getElementById('icb-sticky');
  var stickyPrice = document.getElementById('icb-sticky-price');

  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function activeBody(){ return root.querySelector('.icb-tier-body[data-body="'+state.qty+'"]'); }

  function slotHtml(i){
    var s = state.slots[i], free = (state.qty === 4 && i === 3);
    var label = 'Shirt '+(i+1)+(free ? ' · on us' : '');
    if (!s.handle){
      return '<div class="icb-slot is-empty" data-i="'+i+'">' +
        '<div class="icb-slot-head">' +
          '<span class="icb-slot-empty" aria-hidden="true">+</span>' +
          '<div class="icb-slot-name"><span class="icb-slot-n">'+label+'</span>' +
          '<span class="icb-slot-t">Pick any icon'+(free?'<span class="icb-slot-free">FREE</span>':'')+'</span></div>' +
          '<button type="button" class="icb-choose" data-pick="'+i+'">Choose</button>' +
        '</div><div class="icb-size-hint">Pick an icon for shirt '+(i+1)+'</div></div>';
    }
    var pr = byHandle[s.handle];
    var html = '<div class="icb-slot" data-i="'+i+'">' +
      '<div class="icb-slot-head">' +
        '<img class="icb-slot-img" src="'+esc(pr.img)+'" alt="">' +
        '<div class="icb-slot-name"><span class="icb-slot-n">'+label+'</span>' +
        '<span class="icb-slot-t">'+esc(pr.title)+(free?'<span class="icb-slot-free">FREE</span>':'')+'</span></div>' +
        '<button type="button" class="icb-change" data-pick="'+i+'">Change icon</button>' +
      '</div><div class="icb-sizes">';
    pr.variants.forEach(function(v){
      html += '<button type="button" class="icb-size'+(s.size===v.t?' is-on':'')+'" data-i="'+i+'" data-size="'+esc(v.t)+'"'+(v.a?'':' disabled')+'>'+esc(v.t)+'</button>';
    });
    html += '</div><div class="icb-size-hint">Pick a size for shirt '+(i+1)+'</div></div>';
    return html;
  }

  function renderSlots(){
    root.querySelectorAll('.icb-tier-body').forEach(function(b){ b.innerHTML = ''; });
    var body = activeBody(); if (!body) return;
    var html = '';
    for (var i = 0; i < state.qty; i++) html += slotHtml(i);
    if (state.qty === 1){
      html += '<button type="button" class="icb-nudge" data-nudge="2">' +
        '<span class="icb-nudge-box" aria-hidden="true">+</span>' +
        '<span class="icb-nudge-name"><span class="icb-nudge-t">Add a 2nd shirt</span>' +
        '<span class="icb-nudge-s">10% off and free shipping · mix any icons</span></span></button>';
    }
    body.innerHTML = html;
    updateCta();
  }

  function updateCta(){
    var q = state.qty, total = tierPrice(q);
    atcLabel.textContent = q === 1 ? 'Add to cart' : 'Add ' + q + ' to cart';
    atcPrice.textContent = total;
    stickyPrice.textContent = total + (q > 1 ? ' · ' + q + ' shirts' : '');
    note.textContent = q === 1 ? 'Add a second shirt for free shipping and 10% off.'
      : q === 2 ? '10% off + free shipping applied automatically at checkout.'
      : '4th shirt free + 10% off + free shipping applied automatically at checkout.';
    root.dataset.qty = q;
  }

  function setTier(q){
    state.qty = q;
    root.querySelectorAll('.icb-tier').forEach(function(t){
      var on = Number(t.dataset.tier) === q;
      t.classList.toggle('is-on', on); t.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    renderSlots();
  }

  function pickSize(i, size){
    state.slots[i].size = size;
    renderSlots();
  }

  root.addEventListener('click', function(e){
    var sz = e.target.closest('.icb-size');
    if (sz){ if (!sz.disabled) pickSize(Number(sz.dataset.i), sz.dataset.size); return; }
    var pk = e.target.closest('[data-pick]');
    if (pk){ openSheet(Number(pk.dataset.pick)); return; }
    var nd = e.target.closest('[data-nudge]');
    if (nd){ setTier(Number(nd.dataset.nudge)); return; }
    if (e.target.closest('.icb-tier-body')) return;
    var t = e.target.closest('.icb-tier');
    if (t && !t.classList.contains('is-on')){ setTier(Number(t.dataset.tier)); }
  });
  root.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest && e.target.closest('.icb-tier');
    if (t && e.target === t){ e.preventDefault(); setTier(Number(t.dataset.tier)); }
  });

  /* ---- icon picker sheet ---- */
  var sheet = document.getElementById('icb-sheet'), grid = document.getElementById('icb-sheet-grid'), tabs = document.getElementById('icb-sheet-tabs'), pickFor = 0;
  var sports = data.sports || [], activeSport = data.currentSport || (sports[0] && sports[0].handle) || '';
  function renderTabs(){
    var html = '';
    sports.forEach(function(sp){
      var n = data.products.filter(function(pr){ return pr.sport === sp.handle; }).length;
      if (!n) return;
      html += '<button type="button" role="tab" class="icb-tab'+(sp.handle===activeSport?' is-on':'')+'" data-sport="'+esc(sp.handle)+'" aria-selected="'+(sp.handle===activeSport)+'">'+esc(sp.label)+'</button>';
    });
    tabs.innerHTML = html;
  }
  function renderGrid(){
    var i = pickFor, html = '';
    data.products.forEach(function(pr){
      if (pr.sport !== activeSport) return;
      html += '<button type="button" class="icb-sheet-item'+(state.slots[i].handle===pr.handle?' is-on':'')+'" data-h="'+esc(pr.handle)+'">' +
        '<img src="'+esc(pr.img)+'" alt="" loading="lazy"><span>'+esc(pr.title)+'</span></button>';
    });
    grid.innerHTML = html; grid.scrollTop = 0;
  }
  function openSheet(i){
    pickFor = i;
    var chosen = state.slots[i].handle ? byHandle[state.slots[i].handle] : null;
    activeSport = (chosen && chosen.sport) || (cur && cur.sport) || activeSport;
    renderTabs(); renderGrid();
    sheet.hidden = false; document.body.style.overflow = 'hidden';
  }
  function closeSheet(){ sheet.hidden = true; document.body.style.overflow = ''; }
  sheet.addEventListener('click', function(e){
    if (e.target.closest('[data-close]')){ closeSheet(); return; }
    var tb = e.target.closest('.icb-tab');
    if (tb){ activeSport = tb.dataset.sport; renderTabs(); renderGrid(); return; }
    var it = e.target.closest('.icb-sheet-item');
    if (it){
      var s = state.slots[pickFor]; s.handle = it.dataset.h;
      var pr = byHandle[s.handle];
      var has = function(size){ return pr.variants.some(function(v){ return v.t === size && v.a; }); };
      if (s.size && !has(s.size)) s.size = null;
      // convenience: a freshly chosen shirt inherits the size of shirt 1 when that size exists
      if (!s.size && pickFor > 0 && state.slots[0].size && has(state.slots[0].size)) s.size = state.slots[0].size;
      closeSheet(); renderSlots();
      var el = root.querySelector('.icb-slot[data-i="'+pickFor+'"]');
      if (el && !s.size) el.scrollIntoView({behavior:'smooth', block:'center'});
    }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });

  /* ---- add to cart ---- */
  function variantFor(s){
    if (!s.handle || !s.size) return null;
    var pr = byHandle[s.handle];
    for (var k = 0; k < pr.variants.length; k++) if (pr.variants[k].t === s.size) return pr.variants[k].id;
    return null;
  }
  function firstMissing(){
    for (var i = 0; i < state.qty; i++) if (!variantFor(state.slots[i])) return i;
    return -1;
  }
  function addAll(){
    var missing = firstMissing();
    if (missing >= 0){
      root.querySelectorAll('.icb-slot').forEach(function(x){ x.classList.remove('is-missing'); });
      var el = root.querySelector('.icb-slot[data-i="'+missing+'"]');
      if (el){ el.classList.add('is-missing'); el.scrollIntoView({behavior:'smooth', block:'center'}); }
      return;
    }
    var map = {}, order = [];
    for (var i = 0; i < state.qty; i++){
      var s = state.slots[i], vid = variantFor(s), pr = byHandle[s.handle];
      if (!map[vid]){ map[vid] = { id: Number(vid), quantity: 0, pid: pr.pid, title: pr.title, img: pr.img, size: s.size, price: pr.price, compare: pr.compare, url: pr.url }; order.push(vid); }
      map[vid].quantity++;
    }
    var lines = order.map(function(v){ return map[v]; });
    note.style.color = '';
    var fail = function(err){
      note.textContent = (err && err.message) ? err.message : 'Could not add to cart. Please try again.';
      note.style.color = '#e0362a';
    };
    if (window.ICCart && typeof window.ICCart.add === 'function'){
      atc.classList.add('is-busy');
      window.ICCart.add(lines).then(function(){ updateCta(); }, fail).then(function(){ atc.classList.remove('is-busy'); });
      return;
    }
    atc.disabled = true; var old = atcLabel.textContent; atcLabel.textContent = 'Adding…';
    fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items: lines.map(function(l){ return { id: l.id, quantity: l.quantity }; }) }) })
      .then(function(r){ return r.json(); })
      .then(function(res){ if (res.status) throw new Error(res.description || res.message); window.location.href = '/cart'; })
      .catch(function(err){ fail(err); atc.disabled = false; atcLabel.textContent = old; });
  }
  atc.addEventListener('click', addAll);
  document.getElementById('icb-sticky-btn').addEventListener('click', function(){
    var r = atc.getBoundingClientRect();
    var visible = r.top < window.innerHeight && r.bottom > 0;
    var tier = root.querySelector('.icb-tier.is-on');
    if (firstMissing() >= 0 && !visible && tier){ tier.scrollIntoView({behavior:'smooth', block:'center'}); }
    addAll();
  });

  /* ---- sticky bar visibility (mobile) ---- */
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(en){
      var past = en[0].boundingClientRect.top < 0 && !en[0].isIntersecting;
      sticky.classList.toggle('is-show', past);
      sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(atc);
  }

  /* ---- find your size: height + weight -> size, tuned for the oversized heavyweight cut ---- */
  (function(){
    var fit = document.getElementById('icb-fit'); if (!fit) return;
    var btn = document.getElementById('icb-fit-btn'), panel = document.getElementById('icb-fit-panel');
    var err = document.getElementById('icb-fit-err'), res = document.getElementById('icb-fit-res');
    var hIn = document.getElementById('icb-h'), wIn = document.getElementById('icb-w');
    var hUnit = document.getElementById('icb-h-unit'), wUnit = document.getElementById('icb-w-unit');
    var hu = data.usd ? 'ft' : 'cm', wu = data.usd ? 'lb' : 'kg';
    var ORDER = ['Kids S', 'Kids M', 'Kids L', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
    var ADULT = [['S', 63], ['M', 75], ['L', 87], ['XL', 99], ['2XL', 113], ['3XL', 127]];   // upper bound of height-adjusted kg
    var KIDS = [['Kids S', 126], ['Kids M', 140]];                                              // upper bound of cm
    try {
      var saved = JSON.parse(localStorage.getItem('icb-fit') || 'null');
      if (saved && saved.v === 2){ hu = saved.hu || hu; wu = saved.wu || wu; if (saved.h) hIn.value = saved.h; if (saved.w) wIn.value = saved.w; }
    } catch (e) {}

    function fmtFt(cm){ var t = Math.round(cm / 2.54), f = Math.floor(t / 12), i = t % 12; if (i === 12){ f++; i = 0; } return f + "'" + i + '"'; }
    function parseHeightCm(){
      var v = String(hIn.value || '').trim().replace(/,/g, '.'); if (!v) return 0;
      if (hu === 'cm') return parseFloat(v) || 0;
      var m = v.match(/(\d+(?:\.\d+)?)\D+(\d+(?:\.\d+)?)/);     // 5'9  5 9  5ft 9in  5-9
      if (m) return (parseFloat(m[1]) * 12 + parseFloat(m[2])) * 2.54;
      var n = parseFloat(v); if (!n) return 0;
      if (n > 8) return n * 2.54;                                 // typed total inches
      var f = Math.floor(n), frac = Math.round((n - f) * 10);     // 5.9 -> 5 ft 9 in (how people type it)
      return (f * 12 + (frac >= 10 ? 0 : frac)) * 2.54;
    }
    function parseWeightKg(){ var n = parseFloat(String(wIn.value || '').replace(/,/g, '.')); if (!n) return 0; return wu === 'kg' ? n : n * 0.45359; }
    function setHeightUnit(u){
      if (u === hu) return;
      var cm = parseHeightCm();
      hu = u; hUnit.textContent = u; hIn.placeholder = u === 'cm' ? '175' : '5\'9"';
      if (cm) hIn.value = u === 'cm' ? String(Math.round(cm)) : fmtFt(cm);
      paintUnits();
    }
    function setWeightUnit(u){
      if (u === wu) return;
      var kg = parseWeightKg();
      wu = u; wUnit.textContent = u; wIn.placeholder = u === 'kg' ? '72' : '160';
      if (kg) wIn.value = String(Math.round(u === 'kg' ? kg : kg / 0.45359));
      paintUnits();
    }
    function paintUnits(){
      fit.querySelectorAll('[data-hu]').forEach(function(b){ b.classList.toggle('is-on', b.dataset.hu === hu); });
      fit.querySelectorAll('[data-wu]').forEach(function(b){ b.classList.toggle('is-on', b.dataset.wu === wu); });
      hUnit.textContent = hu; wUnit.textContent = wu;
      hIn.placeholder = hu === 'cm' ? '175' : '5\'9"'; wIn.placeholder = wu === 'kg' ? '72' : '160';
    }
    function open(focus){
      panel.hidden = false; btn.setAttribute('aria-expanded', 'true');
      fit.classList.remove('is-flash'); void fit.offsetWidth; fit.classList.add('is-flash');
      if (focus) fit.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function toggle(){ if (panel.hidden) open(false); else { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); } }
    function recommend(cm, kg){
      if (cm < 152 || (cm < 158 && kg < 45)){
        for (var k = 0; k < KIDS.length; k++) if (cm < KIDS[k][1]) return { size: KIDS[k][0], kids: true };
        return { size: 'Kids L', kids: true };
      }
      var adj = kg + (cm - 175) * 0.3;   // taller frames need the extra length of the next size in an oversized cut
      for (var i = 0; i < ADULT.length; i++) if (adj < ADULT[i][1]) return { size: ADULT[i][0] };
      return { size: '4XL' };
    }
    function neighbours(size){
      var i = ORDER.indexOf(size), kids = i < 3;
      var down = i > 0 && ((i - 1 < 3) === kids) ? ORDER[i - 1] : null;
      var up = i < ORDER.length - 1 && ((i + 1 < 3) === kids) ? ORDER[i + 1] : null;
      return { down: down, up: up };
    }
    function avail(size){
      var pr = byHandle[state.slots[0].handle] || cur;
      return !!(pr && pr.variants.some(function(v){ return v.t === size && v.a; }));
    }
    function cell(size, label, cls){
      return '<span class="' + cls + (size ? '' : ' is-none') + '"><b>' + (size ? esc(size) : '—') + '</b>' + label + '</span>';
    }
    function compute(){
      var cm = parseHeightCm(), kg = parseWeightKg();
      err.classList.remove('is-on');
      if (!(cm >= 90 && cm <= 230) || !(kg >= 20 && kg <= 250)){
        err.textContent = !cm && !kg ? 'Enter a height and a weight.' : !(cm >= 90 && cm <= 230) ? 'Check the height, that does not look right.' : 'Check the weight, that does not look right.';
        err.classList.add('is-on'); res.innerHTML = ''; return;
      }
      try { localStorage.setItem('icb-fit', JSON.stringify({ v: 2, hu: hu, wu: wu, h: hIn.value, w: wIn.value })); } catch (e) {}
      var r = recommend(cm, kg), nb = neighbours(r.size), ok = avail(r.size);
      res.innerHTML =
        '<div class="icb-fit-res">' +
          '<b class="icb-fit-res-s' + (r.kids ? ' is-kids' : '') + '">' + esc(r.size) + '</b>' +
          '<span class="icb-fit-res-l">Your size</span>' +
          '<span class="icb-fit-res-t">' + (r.kids ? 'Kids cut, same oversized look.' : 'Oversized fit, exactly like the photos.') + '</span>' +
          '<span class="icb-fit-res-alt">' + (nb.down ? 'Want it closer to a regular fit? Take <b>' + esc(nb.down) + '</b>.' : 'Free size exchange if it is not right.') + '</span>' +
        '</div>' +
        (data.sketch ? '<div class="icb-fit-sketch-wrap"><img class="icb-fit-sketch" src="' + esc(data.sketch) + '" alt="' + esc(r.size) + ' compared with one size down and one size up" width="1000" height="477">' +
          '<div class="icb-fit-legend">' + cell(nb.down, nb.down ? 'closer fit' : 'smallest size', '') + cell(r.size, 'like the photos', 'is-mid') + cell(nb.up, nb.up ? 'looser' : 'biggest size', '') + '</div></div>' : '') +
        '<button type="button" class="icb-fit-use" data-size="' + esc(r.size) + '"' + (ok ? '' : ' disabled') + '>' + (ok ? 'Use ' + esc(r.size) : esc(r.size) + ' is sold out on this icon') + '</button>';
      res.firstElementChild.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    function applySize(size){
      var changed = false;
      for (var i = 0; i < state.qty; i++){
        var s = state.slots[i]; if (!s.handle) continue;
        var pr = byHandle[s.handle];
        if (pr.variants.some(function(v){ return v.t === size && v.a; }) && (i === 0 || !s.size)){ s.size = size; changed = true; }
      }
      if (changed) renderSlots();
      var slot = root.querySelector('.icb-slot[data-i="0"]');
      if (slot) slot.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    btn.addEventListener('click', toggle);
    fit.addEventListener('click', function(e){
      var t = e.target;
      var u = t.closest('[data-hu]'); if (u){ setHeightUnit(u.dataset.hu); return; }
      var w = t.closest('[data-wu]'); if (w){ setWeightUnit(w.dataset.wu); return; }
      if (t.closest('#icb-fit-go')){ compute(); return; }
      var use = t.closest('.icb-fit-use'); if (use && !use.disabled){ applySize(use.dataset.size); }
    });
    fit.addEventListener('keydown', function(e){ if (e.key === 'Enter' && e.target.tagName === 'INPUT'){ e.preventDefault(); compute(); } });
    document.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('[data-fit-open]')) open(true); });
    paintUnits();
  })();

  renderSlots();
})();

